<template>
  <span class="purpose-badge" :style="{ backgroundColor: backgroundColor }">{{ label }}</span>
</template>

<script>
import {PAYMENT_PURPOSE} from "@/models/paymentPurpose";

// Couleurs de FOND des pastilles de motif d'encaissement (très claires : le texte garde sa couleur normale).
const PURPOSE_BACKGROUND_COLOR = {
  INVOICE: '#dbeafe',      // bleu
  DEPOSIT: '#ffedd5',      // orange
  CREDIT_NOTE: '#ede9fe',  // violet
};

export default {
  name: 'PaymentPurposeBadge',
  props: {
    // Motif de l'encaissement. Les anciens encaissements sans motif (ou REGULAR) sont des encaissements de facture.
    purpose: {type: String, default: undefined},
  },
  computed: {
    resolvedPurpose() {
      return PAYMENT_PURPOSE[this.purpose] ? this.purpose : PAYMENT_PURPOSE.INVOICE.value;
    },
    label() {
      return PAYMENT_PURPOSE[this.resolvedPurpose].label;
    },
    backgroundColor() {
      return PURPOSE_BACKGROUND_COLOR[this.resolvedPurpose];
    },
  },
};
</script>

<style lang="stylus" scoped>
.purpose-badge
  display inline-block
  padding 1px 8px
  border-radius 20px
  font-size 0.85em
  font-weight 600
  line-height 1.5
  white-space nowrap
  color inherit
</style>
